import React, { memo } from "react";
import "./components.css";

interface GovReactCustomHeaderProps {
    "logo.png"?: string | undefined;
    "logo.svg"?: string | undefined;
    HEADER_TEXT?: string | undefined;
    HEADER_URL?: string | undefined;
}

export const GovReactCustomHeader = memo((props: GovReactCustomHeaderProps) => {
    const logoElement = props["logo.png"] ? (
        <img src={`data:image/png;base64,${props["logo.png"]}`} alt={props.HEADER_TEXT || ""} />
    ) : props["logo.svg"] ? (
        <img src={`data:image/svg+xml;base64,${props["logo.svg"]}`} alt={props.HEADER_TEXT || ""} />
    ) : null;
    const headerElement = props.HEADER_TEXT ? <h1>{props.HEADER_TEXT}</h1> : null;
    const logoAndHeader = <div className="preHeader__companyLogo">{logoElement}</div>;
    const anchorElement = props.HEADER_URL ? (
        <a href={props.HEADER_URL} target="_blank">
            {logoAndHeader}
        </a>
    ) : (
        logoAndHeader
    );
    return (
        <div className="preHeader">
            <div className="preHeader__companyBar">
                <>
                    {anchorElement}
                    <div className="preHeader__companyHeader">{headerElement}</div>
                </>
            </div>
        </div>
    );
});
